module.exports = {
          srcSet: __webpack_public_path__ + "70b292b1d7ebf15f3526334723345af7-801.png"+" 801w",
          images:[ {path: __webpack_public_path__ + "70b292b1d7ebf15f3526334723345af7-801.png",width: 801,height: 566}],
          src: __webpack_public_path__ + "70b292b1d7ebf15f3526334723345af7-801.png",
          toString:function(){return __webpack_public_path__ + "70b292b1d7ebf15f3526334723345af7-801.png"},
          
          width: 801,
          height: 566
        }